import React, { useState, PointerEvent, useEffect } from 'react';
import { DeviceTaskType } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { DeviceControlFeature } from 'lavva.exalushome/build/js/Services/Devices/IDeviceTask';
import { GateActionEnum, SetGatePositionPrecise } from 'lavva.exalushome/build/js/Services/Devices/Tasks/Tasks';
import { ControlWrapper, Slider, SubmitButton } from '../../../../../../../components';
import { BlindDetailsControls } from '../../../../../../../components/channel-details-controls/blind/controls';
import { BlindDetailsFavourites } from '../../../../../../../components/channel-details-controls/blind/favourites';
import { defaultFavouritePositionList } from '../../../../../../../const';
import { GateStateTask, DeviceTaskParams } from '../../../../../../../types/actions';
import { useExalusCreateActionContext } from '../../../context';
import { useTaskEdit } from '../../../hooks/use-task-edit';

export const GateSettings: React.FC = () => {
  const { channels } = useExalusCreateActionContext();
  const [gateAction, setGateAction] = useState<GateActionEnum>(GateActionEnum.Open);
  const [sliderValue, setSliderValue] = useState<number>(0);
  const { task, finalizeDeviceTaskSubmit } = useTaskEdit();

  useEffect(() => {
    if (task) {
      const taskState = (task.taskParams as DeviceTaskParams).state as GateStateTask<GateActionEnum>;
      setGateAction(taskState.action);

      switch (taskState.action) {
        case GateActionEnum.Open:
          setSliderValue(0);
          break;
        case GateActionEnum.Close:
          setSliderValue(100);
          break;
        case GateActionEnum.Stop:
          break;
        default:
          setGateAction(GateActionEnum.Percentage);
          if (taskState.position !== null) setSliderValue(taskState.position);
      }
    }
  }, [task]);

  const isOpened = gateAction === GateActionEnum.Open;
  const isClosed = gateAction === GateActionEnum.Close;
  const isStopped = gateAction === GateActionEnum.Stop;

  const handleSliderEvent = (event: PointerEvent<HTMLInputElement>) => {
    setGateAction(GateActionEnum.Percentage);
    setSliderValue(Number((event.target as HTMLInputElement).value));
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setGateAction(GateActionEnum.Percentage);
    setSliderValue(Number(event.target.value));
  };

  const handleConstPercentageChange = (pos: number) => {
    setGateAction(GateActionEnum.Percentage);
    setSliderValue(pos);
  };

  const handleSubmit = () => {
    for (let i = 0; i < channels.length; i++) {
      const task = new SetGatePositionPrecise();
      task.DeviceGuid = channels[i].GetDevice().Guid;
      task.Channel = channels[i].Number;
      task.TaskType = DeviceTaskType.PreciseGateControl;
      task.FeatureType = DeviceControlFeature.SetGatePositionPrecise;
      task.GateControlAction = gateAction;
      if (gateAction === GateActionEnum.Percentage) task.Position = sliderValue;

      finalizeDeviceTaskSubmit(
        task,
        channels[i],
        { position: sliderValue, action: gateAction } as GateStateTask<GateActionEnum>,
        i === channels.length - 1,
      );
    }
  };

  return (
    <>
      <ControlWrapper>
        <Slider value={sliderValue} onPointerUp={handleSliderEvent} onChange={onChange} />
      </ControlWrapper>
      <BlindDetailsControls
        downButton={{
          handleClick: () => {
            setSliderValue(100);
            setGateAction(GateActionEnum.Close);
          },
          active: isClosed,
        }}
        stopButton={{
          handleClick: () => setGateAction(GateActionEnum.Stop),
          active: isStopped,
        }}
        upButton={{
          handleClick: () => {
            setSliderValue(0);
            setGateAction(GateActionEnum.Open);
          },
          active: isOpened,
        }}
      />
      <BlindDetailsFavourites
        favouritePositionList={defaultFavouritePositionList}
        onFavouriteClick={handleConstPercentageChange}
      />
      <SubmitButton onClick={handleSubmit} />
    </>
  );
};
